const html = require('nanohtml')
const _ = require('morphable')
const Course = require('./Course')

module.exports = _(function (semester) {
  return html`<div class="semester">
    <h3>${semester.name} <button class="pure-button" onclick=${() => confirm('Are you sure you want to clear this semester?') ? semester.remove() : ``}>x</button></h3>
    <div class="x-scroll">
      <table class="courses pure-table">
        ${semester.courses.length > 0 ? html`<thead><td>Course</td><td>Grade</td><td>Credits</td><td>Weighting</td><td></td></thead>` : ``}
        ${semester.courses.map(course => Course(course, semester))}
      </table>
    </div>
    <footer>
      <div class="semester-tools">
        <button class="pure-button" onclick=${() => semester.newCourse()}>Add a Course</button>
      </div>
      <div class="semester-gpa">
        <h3>${semester.name} Weighted GPA: ${(semester.gpa || 0).toFixed(2)}</h3>
        <h4>Unweighted: ${(semester.unweighted || 0).toFixed(2)}</h4>
        <h4>Credits: ${semester.credits || 0}</h4>
      </div>
    </footer>
  </div>`
})
